/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';

export enum ActionTypes {
  Change = '[Dashboard] Options changed',
  SelectReport = '[Dashboard] Report selected',
  Reset = '[Dashboard] Options reset'
}

export class Change implements Action {
  readonly type = ActionTypes.Change;

  // type is any to allow updates of single option
  constructor(public payload: { options: any }) {}
}

export class SelectReport implements Action {
  readonly type = ActionTypes.SelectReport;

  constructor(public payload: { index: number }) {}
}

export class Reset implements Action {
  readonly type = ActionTypes.Reset;
}

export type ActionList = Change | SelectReport | Reset;
